import { Component } from '@angular/core';
import { Maps, MapsTooltip, ISelectionEventArgs, Selection, Highlight, MapsModule, MapsTooltipService, DataLabelService } from '@syncfusion/ej2-angular-maps';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { DataService } from '../../../../../../services/dashboard/data.service';
import { italyMap } from '../../../../../../shared/italy-regions';
import { NtPotentialRegionInterface } from '../../../../../../shared/interfaces/nt-potential-region.interface';
import { ModalInclusionPerRegComponent } from '../modal-inclusion-per-reg/modal-inclusion-per-reg.component';
import { CommonModule } from '@angular/common';
import { NtOpenToAccessMapInterface } from '../../../../../../shared/interfaces/nt-openToAccess-map-interface';

Maps.Inject(MapsTooltip, Selection, Highlight);

@Component({
  selector: 'app-map-open-to-access-regions',
  imports: [MapsModule, CommonModule],
  providers: [MapsTooltipService, DataLabelService],
  templateUrl: './map-open-to-access-regions.component.html',
  styleUrl: './map-open-to-access-regions.component.css'
})
export class MapOpenToAccessRegionsComponent {
  public mapWidth: string = '98%';
  public mapHeight: string = '98%';

  public medicineId = 0;
  public countryId = 1;
  public regionId = 0;
  public regionName = '';

  public isModalInclusioneActive: boolean = false;

  public layers?: object[];

  /*regions:NtOpenToAccessMapInterface[]=
  [
  { regionId: 14, regionName: 'Abruzzo', isCompleted: false },
  { regionId: 18, regionName: 'Basilicata', isCompleted: false },
  { regionId: 19, regionName: 'Calabria', isCompleted: true },
  { regionId: 16, regionName: 'Campania', isCompleted: false },
  { regionId: 9, regionName: 'Emilia-Romagna', isCompleted: false },
  { regionId: 7, regionName: 'Friuli Venezia Giulia', isCompleted: true },
  { regionId: 13, regionName: 'Lazio', isCompleted: false },
  { regionId: 8, regionName: 'Liguria', isCompleted: false },
  { regionId: 3, regionName: 'Lombardia', isCompleted: true },
  { regionId: 12, regionName: 'Marche', isCompleted: false },
  { regionId: 15, regionName: 'Molise', isCompleted: false },
  { regionId: 2, regionName: 'Piemonte', isCompleted: true },
  { regionId: 5, regionName: 'Prov. Aut. di Bolzano', isCompleted: false },
  { regionId: 4, regionName: 'Prov. Aut. di Trento', isCompleted: false },
  { regionId: 17, regionName: 'Puglia', isCompleted: true },
  { regionId: 21, regionName: 'Sardegna', isCompleted: false },
  { regionId: 20, regionName: 'Sicilia', isCompleted: false },
  { regionId: 10, regionName: 'Toscana', isCompleted: true },
  { regionId: 11, regionName: 'Umbria', isCompleted: false },
  { regionId: 1, regionName: "Valle D'Aosta", isCompleted: false },
  { regionId: 6, regionName: 'Veneto', isCompleted: false }
]*/


  constructor (private dataService: DataService) { }


  ngOnInit (): void {

    this.layers = [
      {
        shapeData: italyMap
      }
    ];

    this.medicineId = sessionStorage.getItem('medicineId') ? Number(sessionStorage.getItem('medicineId')) : 0;
    this.countryId = sessionStorage.getItem('countryId') ? Number(sessionStorage.getItem('countryId')) : 1;

    this.dataService.getHeatmapRegionalAccessData(this.medicineId, this.countryId).subscribe({
      next: (data: NtOpenToAccessMapInterface[]) => {
        this.loadData(data);
      },
      error: (error) => {
        console.error('Errore nel recupero dei dati della mappa regionale:', error);
      }
    });
    /*
        this.dataService.medicineUpdated$.subscribe((medicineId: number) => {
          if (medicineId !== 0) {
            this.medicineId = medicineId;
            this.loadData();  // Ricarica i dati quando cambia il medicineId
          }
        });
    */
  }

  loadData (regions: NtOpenToAccessMapInterface[]): void {
    const regioniHeatmapData = regions.map(item => {
      let statusText = '';

      if (item.isCompleted === true) {
        statusText = 'Apertura';
      } else {
        statusText = 'Chiusura';
      }

      return {
        regionId: item.regionId,
        regionName: item.regionName,
        isCompleted: item.isCompleted,
        tooltipText: `${
    item.regionName === 'Prov. Aut. di Bolzano' ? 'PA di Bolzano' :
    item.regionName === 'Prov. Aut. di Trento' ? 'PA di Trento' :
    item.regionName
  }: <br> ${statusText}`
      };
    });

    this.layers = [
      {
        shapeData: italyMap,
        shapePropertyPath: 'id',
        shapeDataPath: 'regionId',
        dataSource: regioniHeatmapData,
        tooltipSettings: {
          visible: true,
          valuePath: 'tooltipText',
        },
        highlightSettings: {
          enable: false,
          fill: '#00CEBC'
        },
        selectionSettings: {
          enable: false,
          fill: '',
          opacity: 1,
        },
        shapeSettings: {
          border: {
            color: '#FFFFFF',
            width: 0.4,
          },
          colorValuePath: 'isCompleted',
          colorMapping: [
            {
              value: true,
              color: '#008236'
            },
            {
              value: false,
              color: '#C10007'
            }
          ]
        }
      }
    ];
  }

  public itemSelection = (args: ISelectionEventArgs) => {
    if (args.shapeData !== isNullOrUndefined) {
      this.isModalInclusioneActive = true;
      this.regionId = Number((args.data as NtPotentialRegionInterface).regionId)
      this.regionName = (args.data as NtPotentialRegionInterface).regionName
    }
  };

  showModalInclusione (value: boolean) {
    this.isModalInclusioneActive = value;
  }
}
